import React from 'react';
import { Box, Typography, Button, TextField } from '@material-ui/core';
interface UploadFileDefinition {
    label: string,
    allowedTypes?: string[],
    fileName?: string
}
interface UploadConfig {
    s3Path: string;
    filesRequired: number;
    files?: UploadFileDefinition[];
}

interface FileUploadSectionProps {
    config: UploadConfig;
    onFileChange: (index: number, file: File | null) => void;
    onUpload: (index: number) => void;
    onDownload?: (index: number) => void;
    downloadLinks?: Record<string, string>;
    showDownload?: boolean;
    isCheckingFiles?: boolean;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
    config,
    onFileChange,
    onUpload,
    onDownload,
    downloadLinks = {},
    showDownload = false,
    isCheckingFiles = false,
}) => {
    const { s3Path, filesRequired, files = [] } = config;
    return (
        <Box mt={3}>
            <Typography variant='subtitle1' gutterBottom>
                S3 Upload Path: <strong>{s3Path}</strong>
            </Typography>

            <Typography variant='subtitle2'>
                Please upload {filesRequired} file(s):
            </Typography>

            {Array.from({ length: filesRequired }).map((_, i) => {
                const fileName = files[i]?.fileName;
                const downloadUrl =
                    fileName && downloadLinks[fileName]
                        ? downloadLinks[fileName]
                        : '';
                return (
                    <Box key={i} my={2}>
                        <Typography variant='body2' gutterBottom>
                            {files[i]?.label
                                ? `Upload ${files[i].label}:`
                                : `File ${i + 1}`}
                        </Typography>

                        <Box display='flex' alignItems='center'>
                            <TextField
                                type='file'
                                inputProps={{
                                    accept: files[i]?.allowedTypes?.join(','),
                                }}
                                fullWidth
                                onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                ) =>
                                    onFileChange(
                                        i,
                                        e.target.files?.[0] || null
                                    )
                                }
                            />

                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => onUpload(i)}
                            >
                                Upload
                            </Button>
                            {showDownload && downloadUrl && (
                                <Button
                                    variant='outlined'
                                    color='primary'
                                    style={{ marginLeft: 8 }}
                                    onClick={() => onDownload?.(i)}
                                >
                                    Download
                                </Button>
                            )}
                        </Box>
                        {showDownload &&
                            fileName &&
                            !downloadUrl &&
                            !isCheckingFiles && (
                                <Typography
                                    variant='caption'
                                    color='textSecondary'
                                >
                                    No file uploaded yet.
                                </Typography>
                            )}
                        {showDownload && fileName && isCheckingFiles && (
                            <Typography variant='caption' color='textSecondary'>
                                Checking file availability...
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};


export default FileUploadSection;
